import React from 'react';
import { Observe } from 'rewire-core';
import { withStyles } from 'rewire-ui';
import Typography from '@material-ui/core/Typography';
import { Theme, makeStyles } from '@material-ui/core/styles';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { ArrowUpDownBold as SortIcon } from 'mdi-material-ui';
import OptionsToggleMenu, { OptionsToggleMenuProps } from './OptionsToggleMenu';
import PrioritySortMenuModel from './PrioritySortMenuModel';

const sortngItemIconStyles = (_theme: Theme) => ({
  priorityText: {
    paddingLeft: '2px',
  },
});

const useSortingItemIconStyles = makeStyles(sortngItemIconStyles);

export const getSortingItemIcon = (model: PrioritySortMenuModel, sortingItemName: string) => (): JSX.Element | null => {
  const classes = useSortingItemIconStyles();

  return (
    <Observe
      render={() => {
        const sortObj = model.getSortByName(sortingItemName);
        const sortDirection = model.isSingleSelectMode
          ? model.getSortPriority(sortObj?.priority) === 1
            ? sortObj?.direction
            : undefined
          : sortObj?.direction;
        const priority = !sortObj || model.isSingleSelectMode ? '' : model.getSortPriority(sortObj.priority);
        const Icon = !sortDirection ? undefined : sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon;
        return Icon ? (
          <>
            <Icon />
            <Typography className={classes.priorityText}>{priority}</Typography>
          </>
        ) : null;
      }}
    />
  );
};

const styles = (theme: Theme) => ({
  menuButton: {},
  menu: {},
  menuTitleContainer: {},
  listItemText: {},
  listItemTypography: {},
  listItemIcon: {},
  menuItem: {},
  menuItemSelected: {},
  menuItemDisabled: {},
  hasSelection: {
    color: theme.palette.secondary.main,
  },
});

interface IPrioritySortMenuProps {
  model: PrioritySortMenuModel;
}

export type PrioritySortMenuProps = IPrioritySortMenuProps &
  Omit<OptionsToggleMenuProps & { classes?: { hasSelection: any } }, 'title' | 'tooltip' | 'items'>;

class PrioritySortMenu extends React.Component<PrioritySortMenuProps> {
  constructor(props: PrioritySortMenuProps) {
    super(props);
  }

  render() {
    const { model, classes, ...restProps } = this.props;
    const { hasSelection, ...restClasses } = classes;

    return (
      <Observe
        render={() => {
          const sortTooltip = model.getSortTooltip();
          const sortMenuItems = model.getSortMenuItems();

          return sortMenuItems && sortMenuItems.length > 0 ? (
            <OptionsToggleMenu
              title={model.title}
              tooltip={sortTooltip}
              buttonContent={<Observe render={() => <SortIcon className={model.hasSorts ? hasSelection : ''} />} />}
              items={sortMenuItems}
              onItemClick={model.handleItemClick}
              classes={restClasses}
              {...(restProps as any)}
            />
          ) : null;
        }}
      />
    );
  }
}

export default withStyles<Omit<PrioritySortMenuProps, 'classes'>, any>(styles, PrioritySortMenu);
